import React from 'react';
import PropTypes from 'prop-types';

import {
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CommonDialog = ({
    children,
    open,
    fullWidth,
    maxWidth,
    title,
    handleClose,
    actionButtons,
    paperSx,
    actionsSx,
    contentSx
}) => {

    return (
        <Dialog
            open={open}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            onClose={handleClose}
            PaperProps={{ sx: paperSx }}
        >
            <DialogTitle sx={{ fontWeight: '700' }}>{title}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={contentSx}>
                {children}
            </DialogContent>
            <DialogActions sx={{
                justifyContent: 'flex-start',
                backgroundColor: '#FFF',
                boxShadow: '0px 6px 30px 5px rgba(0, 0, 0, 0.12), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 8px 10px -5px rgba(0, 0, 0, 0.20)',
                padding: '15px',
                ...actionsSx
            }}>
                {
                    actionButtons ? actionButtons : (
                        <Button onClick={handleClose}>Close</Button>
                    )
                }
            </DialogActions>
        </Dialog>
    );
}

CommonDialog.propTypes = {
    children: PropTypes.node.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    maxWidth: PropTypes.string,
    actionButtons: PropTypes.node,
    paperSx: PropTypes.object,
    actionsSx: PropTypes.object,
    contentSx: PropTypes.object,
};

CommonDialog.defaultProps = {
    fullWidth: true,
    maxWidth: 'md'
};

export default CommonDialog;